export default __webpack_public_path__ + "81c7ed1eeb576ffd5ece0c046ba5d143.png";